export default __webpack_public_path__ + "static/media/home.f237b7a7.svg";